import { useEffect, useState } from 'react'
import EmptyDisplay from '../EmptyDisplay/EmptyDisplay'
import './profileorders.scss'
import { loadOrders } from '../../api/requests'
import { OrderHistory } from '../../interface/interfaces'
import { useNotification } from '../../context/NotificationContext'
import SkeletonLoader from '../SkeletonLoaders/DefaultLoader'
import { NavLink } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'


type Props={
    num:number
}

const ProfileOrders=({num}:Props)=>{

    type PageData={
        orders:OrderHistory[],
        isLoading:boolean
    }

    const  {notify}=useNotification()
     const [pageData,setPageData]=useState<PageData>({
        orders:[],
        isLoading:false
     })


     useEffect(()=>{

        const init=async ()=>{

            try {
                setPageData((prev)=>{
                    return {
                        ...prev,
                        isLoading:true
                    }
                })
                let data= await loadOrders(1,num)
                setPageData((prev)=>{
                    return {
                        ...prev,
                        orders:data.orderHistory
                    }
                })
            } catch (error:any) {
                notify.error(error.message)
            } finally{
                 setPageData((prev)=>{
                    return {
                        ...prev,
                        isLoading:false
                    }
                })
            }

        }


        init()
// eslint-disable-next-line
     },[])

         const dateFunc = (rawDate: string): string => {
        const date = new Date(rawDate);

        const opts: Intl.DateTimeFormatOptions = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        };

        const formatted = date.toLocaleDateString('en-US', opts);
        return formatted;
    };

   const colorFunc = (
        text: string
    ): 'green' | 'yellow' | 'red' | 'default' => {
        const normalized = text.trim().toLowerCase();

        const colorMap: Record<'green' | 'yellow' | 'red', string[]> = {
            green: ['created', 'ready', 'delivered','picked_up','picked up','dispatched','assigned to a rider'],
            yellow: [
                'awaiting vendor confirmation','awaitingconfirmation',
                'pending pick-up','pendingpickup',
                'returned',
            ],
            red: ['cancelled'],
        };

        for (const [color, keywords] of Object.entries(colorMap) as [keyof typeof colorMap, string[]][]) {
            if (keywords.some(k => normalized === k)) {
                return color;
            }
        }

        return 'default';
    };


    const isTxSuccess=(id:string)=>{

        let obj=pageData.orders.find((data)=>{
            return data.id === id
        })

        let raw_text=(obj!.transaction_status).toLowerCase()

        if(raw_text==='success'){
            return true
        }else{
            return false
        }

    }


    

    return (
    <div className="profileorders">

        {pageData.isLoading && (<SkeletonLoader count={3}></SkeletonLoader>)}

        {!pageData.isLoading && (
            <>
            {pageData.orders.length >= 1 && (
                <div className="order-table">
            <div className="order-header">
                <div className='eachH'>Order ID</div>
                <div className='eachH'>Status</div>
                <div className='eachH'>Date</div>
                <div className='eachH'>Total</div>
                <div className='eachH'></div>
            </div>


              {pageData.orders.map((data, idx) => (
                            <div className="order-item" key={idx}>


                                <div className='eachdata'>
                                    <div className='smalltitle'>Order Id</div>
                                    <span className='orderid'>{data.order_id}</span>
                                </div>

                                {isTxSuccess(data.id) && (<div className="eachdata">
                                    <div className='smalltitle'>Status</div>
                                    <div className={`orderstatus ${colorFunc(data.status)}`}>{data.status}</div>
                                </div>)}

                                {!isTxSuccess(data.id) && (<div className="eachdata">
                                    <div className='smalltitle'>Status</div>
                                    <div className={`orderstatus yellow`}>Awaiting Payment</div>
                                </div>)}

                                

                                <div className='eachdata'>
                                    <div className='smalltitle'>Date</div>
                                    <span className='text'>{dateFunc(data.order_date)}</span>
                                </div>

                                <div className='eachdata'>
                                    <div className='smalltitle'>Total</div>
                                    <span className='text'>₦{(data.amount).toLocaleString()}</span>
                                </div>

                                <div className='eachdata'>

                                    <NavLink to={`/order/${data.order_id}`}>
                                        <div className='view-order'>
                                            <span>View Order</span>
                                            <ArrowRight size={16} strokeWidth={2.5}></ArrowRight>
                                        </div>
                                    </NavLink>


                                </div>

                            </div>
                        ))}

            


        </div>
            )}

            {pageData.orders.length <= 0 && (<EmptyDisplay text='No new orders yet' icon_class=''></EmptyDisplay>)}
            </>
        )}


    </div>)
}


export default ProfileOrders;